import React, { Component } from 'react'
import classnames from "classnames";

import baseStyles from 'custom/base.styl';
import grid from './../../styles/grid.styl';

import ill from './../../img/tutorial/ill@3x.png';

class TutorialStep1 extends Component {
  render() {
    return (
      <div className={classnames(baseStyles.tutorial_content_step, baseStyles.tutorial_content_step1)}>

        <div className={classnames(grid.row, baseStyles.mb_30)}>
          <div className={classnames(grid.col_4)}>
            <h3>1. Plan</h3>
            <p>Follow the Instructions</p>
            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__default)}>
              <li>Read the requirements</li>
              <li>Outline main tasks</li>
            </ul>
          </div>
          <div className={classnames(grid.col_4)}>
            <h3>2. Research</h3>
            <p>Use the Sources</p>
            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__default)}>
              <li>Find reliable sources</li>
              <li>Outline main ideas</li>
              <li>Cite all outside information</li>
            </ul>
          </div>
          <div className={classnames(grid.col_4)}>
            <h3>3. Organize</h3>
            <p>Develop the Structure</p>
            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__default)}>
              <li>Set up logical sections</li>
              <li>Use linking words and <br/> phrases</li>
            </ul>
          </div>
        </div>

        <div className={grid.row}>
          <div className={classnames(grid.col_4)}>
            <h3>4. Write</h3>
            <p>Use Proper Language</p>
            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__default, baseStyles.mb_0)}>
              <li>Use the academic style</li>
              <li>Use simple & conventional <br/> grammar</li>
            </ul>
          </div>
          <div className={classnames(grid.col_4)}>
            <h3>5. Revise</h3>
            <p>Apply Formatting</p>
            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__default, baseStyles.mb_0)}>
              <li>Use the template</li>
              <li>Proofread for typos</li>
            </ul>
          </div>
          <div className={classnames(grid.col_4)}>
          </div>
        </div>

        <div className={baseStyles.content_wrap}>
          <img className={baseStyles.hide_xs} src={ill} alt="ill" width="198px" />
        </div>
      </div>
    )
  }
}

export default TutorialStep1;



// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep1.js